// Поле «поиск по названию» для списков (отели, экскурсии, транспорт, поезда, направления): значок, ввод, кнопка очистки
import { Icon } from './Icon';

export interface SearchFieldProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function SearchField({ id, value, onChange, placeholder = 'Название' }: SearchFieldProps) {
  return (
    <label className="budget search-field">
      <Icon name="search" />
      <input id={id} type="search" enterKeyHint="search" autoComplete="off" placeholder={placeholder} aria-label={placeholder} value={value}
        onChange={(e) => onChange(e.target.value)} onKeyDown={(e) => { if (e.key === 'Escape' && value) { e.preventDefault(); onChange(''); } }} />
      {value ? <button type="button" className="search-clear" aria-label="Очистить" onClick={() => onChange('')}><Icon name="x" /></button> : null}
    </label>
  );
}
